import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DeviceManagementService } from './device-management.service';
import { RegisteredDeviceSituationEnum, RegisteredDeviceType } from './models/registered-device';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../../shared/EventTypes';
import * as moment from 'moment';
import { DeviceRegistrationModalComponent } from './device-registration-modal/device-registration-modal.component';
import { Util } from '../../utils/util';

@Component({
	selector: 'app-device-management',
	templateUrl: './device-management.component.html',
	styleUrls: ['./device-management.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DeviceManagementComponent implements OnInit {

	constructor(
		private readonly deviceManagementService: DeviceManagementService,
		public dialog: MatDialog,
	) { }

	public registeredDevice: RegisteredDeviceType;

	ngOnInit() {
		this.getRegisteredDevice();
	}

	getRegisteredDevice() {
		this.deviceManagementService.getRegisteredDevice().subscribe(data => {
			this.registeredDevice = data;

		}, error => {
			this.handleError(error);
		});
	}

	openRegisterDeviceDialog() {
		const width = this.isMobile ? '100%' : '600px';
		const dialogConfig: MatDialogConfig = {
			width: width,
			maxWidth: width,
			height: this.isMobile ? '100%' : '484px',
			panelClass: 'round-dialog',
		};
		this.dialog.open(
			DeviceRegistrationModalComponent,
			dialogConfig
		);
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.messages[0] });

	get isMobile() {
		return Util.isMobile();
	}

	get title() {
		if (!this.registeredDevice) return 'Não há nenhum dispositivo registrado em sua conta.';
		return "Dispositivos registrados";
	}

	get formattedRegistrationDate() {
		if (!this.registeredDevice) return null;
		const date = moment.utc(this.registeredDevice.Data, 'YYYY-MM-DD').format('DD MMM YYYY');
		return `Habilitado em ${date}`;
	}

	get registeredDeviceStatus() {
		if (!this.registeredDevice) return null;
		switch (this.registeredDevice.Situacao) {
			case RegisteredDeviceSituationEnum.ACTIVE:
				return 'Registro ativo';
			case RegisteredDeviceSituationEnum.BLOCKED:
				return 'Bloqueado';
			case RegisteredDeviceSituationEnum.PENDING_APPROVAL:
				return 'Pendente de aprovação';
			default:
				return '';
		}
	}

	get tagVariantPerStatus() {
		if (!this.registeredDevice) return null;
		switch (this.registeredDevice.Situacao) {
			case RegisteredDeviceSituationEnum.BLOCKED:
				return 'red';
			case RegisteredDeviceSituationEnum.PENDING_APPROVAL:
				return 'yellow';
			case RegisteredDeviceSituationEnum.ACTIVE:
			default:
				return 'green';
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/device-management/device-management.component.ts